import headerImage1Url from './assets/header-image-1.jpg';

export type BenefitItem = {
  messageId: string;
  isFree?: boolean;
};

export type PageTemplate = {
  headerImageUrl: string;
  titleMessageId: string;
  subtitleMessageId: string;
  benefits: BenefitItem[];
};

const DEFAULT_TEMPLATE: PageTemplate = {
  headerImageUrl: headerImage1Url,
  titleMessageId: 'plans_page_v5_header_v2',
  subtitleMessageId: 'plans_page_v5_description',
  benefits: [
    { messageId: 'plans_page_v5_benefit1', isFree: true },
    { messageId: 'plans_page_v5_benefit2', isFree: true },
    { messageId: 'plans_page_v5_benefit3', isFree: true },
    { messageId: 'plans_page_v5_benefit4' },
    { messageId: 'plans_page_v5_benefit5' },
    { messageId: 'plans_page_v5_benefit6' },
    { messageId: 'plans_page_v5_benefit7' },
    { messageId: 'plans_page_v5_benefit8' },
    { messageId: 'plans_page_v5_benefit9' },
    { messageId: 'plans_page_v5_benefit10' },
    { messageId: 'plans_page_v5_benefit11' },
    { messageId: 'plans_page_v5_benefit12' },
    { messageId: 'plans_page_v5_benefit13' },
  ],
};

const DEFAULT_TEMPLATE_2024: PageTemplate = {
  headerImageUrl: headerImage1Url,
  titleMessageId: 'plans_page_v4_header',
  subtitleMessageId: 'plans_page_v4_description',
  benefits: [
    { messageId: 'plans_page_v4_benefit1', isFree: true },
    { messageId: 'plans_page_v4_benefit2', isFree: true },
    { messageId: 'plans_page_v4_benefit3', isFree: true },
    { messageId: 'plans_page_v4_benefit4', isFree: true },
    { messageId: 'plans_page_v4_benefit5', isFree: true },
    { messageId: 'plans_page_v4_benefit6' },
    { messageId: 'plans_page_v4_benefit7' },
    { messageId: 'plans_page_v4_benefit8' },
    { messageId: 'plans_page_v4_benefit9' },
    { messageId: 'plans_page_v4_benefit10' },
    { messageId: 'plans_page_v4_benefit11' },
  ],
};

export const PAGE_TEMPLATES: { default: PageTemplate; default2024: PageTemplate } & Record<
  string,
  PageTemplate | undefined
> = {
  default: DEFAULT_TEMPLATE,
  default2024: DEFAULT_TEMPLATE_2024,
};
